"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzCheck__Wrapper",
  componentId: "sc-lv88x7-0"
})(["\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzCheck__Container",
  componentId: "sc-lv88x7-1"
})(["\n  position: relative;\n  display: inline-block;\n  border-radius: 5px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  ", ";\n"], function (props) {
  return props.variant === "default" ? "\n    border: 1px solid " + (props.disabled ? "#CBCBCB21" : "#CBCBCB") + ";\n    background: " + (props.disabled ? "#EBEBEB" : props.selected ? "#687FE2" : "#ffffff") + ";\n  " : props.variant === "charcoal" ? "\n    border: 1px solid " + (props.disabled ? "#20283321" : "#202833") + ";\n    background: " + (props.disabled ? "#EBEBEB" : props.selected ? "#455262" : "#455262") + ";\n  " : null;
});

var OzCheckbox = function OzCheckbox(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      label = _ref.label,
      description = _ref.description,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return __jsx(Wrapper, null, __jsx(Container, {
    variant: variant,
    disabled: disabled,
    selected: selected,
    onClick: function onClick() {
      if (!disabled) {
        if (onChange) {
          onChange(!selected);
        }
      }
    }
  }, __jsx(_OzIcon.default, {
    name: "tick",
    size: "12px",
    color: selected ? "#ffffff" : "transparent"
  })));
};

var _default = OzCheckbox;
exports.default = _default;